import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { Button, Grid } from "@mui/material";
import { useFormik } from "formik";
import Input from "../../../../../components/Input";
import { AdminProfileType } from "../../../../../constants/AdminProfileFormSchemas";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import { STAFF_USER_ROLE_OPTIONS } from "../../../../../constants/master";
import DropZone from "../../../../../components/app/DropZone";
import { useUpdateUser } from "../../../../../queries/use-update-user";
import CustomSelect from "../../../../../components/CustomSelect";
import {
  convertToBase64,
  getErrorSnackbar,
  getSuccessSnackbar,
} from "../../../../../utils/utils";
import { useQueryClient } from "@tanstack/react-query";
import { useProfileAvatar } from "../../../../../queries/use-profile-avatar";
import MaskInput from "../../../../../components/MaskInput";
import * as Yup from "yup";
import { useEffect } from "react";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
interface EditProfileModalProps {
  profileData: AdminProfileType;
  open: boolean;
  handleCloseEditModal: () => void;
}

const EditProfileModal = ({
  profileData,
  open,
  handleCloseEditModal,
}: EditProfileModalProps) => {
  const showSnackbar = useSnackbar();
  const { mutateAsync: updateAvatar } = useProfileAvatar();
  const { mutateAsync: UpdateUser } = useUpdateUser();
  const queryClient = useQueryClient();
  const formik = useFormik({
    initialValues: profileData,
    // validationSchema: ADMIN_PROFILE_VALIDATION_SCHEM,
    validationSchema: Yup.object({
      phone: Yup.string().min(12, "Contact Number must be at least 8 digits"),
      // .required()
      // .label("Phone Number"),
    }),
    onSubmit,
    enableReinitialize: true,
  });

  useEffect(() => {
    open && formik.setValues(profileData);
  }, [open]);

  function onSubmit(values: AdminProfileType) {
    UpdateUser({ user: { ...values } } as any)
      .then((res) => {
        showSnackbar(getSuccessSnackbar(res));
        if (!values?.avatar?.includes(".amazonaws.com")) {
          updateAvatar({
            newAvatar: { newAvatar: values.avatar, userId: values.uuid },
          })
            .then((res) => {
              queryClient.invalidateQueries({
                queryKey: ["user-profile"],
              });
              showSnackbar(getSuccessSnackbar(res));
            })
            .catch((err) => showSnackbar(getErrorSnackbar(err)));
        }

        formik.resetForm();
        queryClient.invalidateQueries({
          queryKey: ["user-profile"],
        });

        handleCloseEditModal();
      })
      .catch((err) => showSnackbar(getErrorSnackbar(err)));
  }

  return (
    <SideSheetDrawer
      open={open}
      title="Edit Admin Profile"
      onClose={handleCloseEditModal}
      footerActions={
        <Button
          sx={{ width: "7.5rem" }}
          variant="contained"
          onClick={() => {
            formik.handleSubmit();
          }}
          type="submit"
        >
          Save
        </Button>
      }
    >
      <Grid
        container
        width={{
          sm: "500px",
          md: "600px",
          lg: "850px",
        }}
      >
        <Grid item container xs={5}>
          <Grid item mb={3}>
            <DropZone
              label="Profile Photo"
              value={formik.values?.avatar}
              content="Upload Profile Photo"
              height={"170px"}
              backgroundColor={"primary.light"}
              uploadIcon={<AddPhotoAlternateIcon sx={{ fontSize: "3rem" }} />}
              onClick={async (files) => {
                if (files) {
                  const base64File = await convertToBase64(files[0]);
                  formik.setFieldValue("avatar", base64File);
                } else formik.setFieldValue("avatar", null);
              }}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={4} sm={12} lg={6}>
            <Input
              label="First Name"
              textFieldProps={{
                placeholder: "Enter First Name",
                onChange: formik.handleChange,
                onBlur: formik.handleBlur,
                name: "firstName",
                value: formik.values?.firstName,
              }}
            />
          </Grid>
          <Grid item xs={4} sm={12} lg={6}>
            <Input
              label="Last Name"
              textFieldProps={{
                placeholder: "Enter Last Name",
                onChange: formik.handleChange,
                onBlur: formik.handleBlur,
                name: "lastName",
                value: formik.values?.lastName,
              }}
            />
          </Grid>

          <Grid item xs={4} sm={12} lg={6}>
            <Input
              label="Email"
              textFieldProps={{
                placeholder: "Enter Email",
                onChange: formik.handleChange,
                onBlur: formik.handleBlur,
                name: "email",
                value: formik.values?.email,
              }}
            />
          </Grid>
          <Grid item xs={4} sm={12} lg={6}>
            <MaskInput
              mask={"(999) 999-9999"}
              label="Contact Number"
              name="phone"
              error={formik.errors?.phone}
              placeholder="Enter Contact Number"
              value={formik.values?.phone}
              onChange={(e) => formik.setFieldValue("phone", e.target.value)}
            />
          </Grid>
          <Grid item xs={4} sm={12} lg={6}>
            <CustomSelect
              readOnly
              label="Role"
              placeholder="Select Role"
              options={[
                ...STAFF_USER_ROLE_OPTIONS,
                { value: "SUPER_ADMIN", label: "Super Admin" },
              ]}
              value={formik.values?.role}
              onChange={(value) => formik.setFieldValue("role", value)}
            />
          </Grid>
        </Grid>
      </Grid>
    </SideSheetDrawer>
  );
};
export default EditProfileModal;
